export enum Flags {
  SELLER_CORE_SIGNUP_DISABLED = 'seller_core_signup_disabled',
}
